import { renderApp } from './App';

renderApp();
